import React from "react";

import ListItem from "@mui/joy/ListItem";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import ListItemContent from "@mui/joy/ListItemContent";
import Typography from "@mui/joy/Typography";
import Link from "@mui/joy/Link";
import Tooltip from "@mui/joy/Tooltip";
import {CircularProgress, Stack} from "@mui/joy";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import BaseApi from "../../utils/BaseApi";
import {b64toBlob, downloadBlob} from "../../utils/misc";
import {fileTypeIcons} from "../../theme";
import ProfileHorizontalByProps from "../Profile/ProfileHorizontalByProps";

//icons
import FilePresentIcon from '@mui/icons-material/FilePresent';
import DeleteIcon from "@mui/icons-material/Delete";
import ConfidentialAttachmentAddMember from "./ConfidentialAttachmentAddMember";


class ConfidentialAttachmentCard extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            download: false,
        }
        this.fileTypeIcons = fileTypeIcons
        this.fileType = this.props.attachment.uploadname.split('.').slice(-1)
    }

    async destroy() {
        const url = `confidential_attachment/${this.props.attachment.id}/`;
        const api = new BaseApi();
        await api.delete(url, {});
        await this.props.callBack();
    }

    async download(){
        this.setState({
            download: true
        })
        const api = new BaseApi();
        const url = `confidential_attachment/${this.props.attachment.id}/download/`;
        let response = await api.get(url, {});
        downloadBlob(
            b64toBlob(response.data.content),
            response.data.filename,
            ''
        )
        this.setState({
            download: false
        })
    }

    render() {
        return(
            <ListItem
                sx={{
                    width: '100%',
                }}
            >
                <ListItemDecorator
                    sx={{
                        mr: 2,
                    }}
                >
                    {
                        this.fileType in this.fileTypeIcons?
                        this.fileTypeIcons[this.fileType]:
                        <FilePresentIcon color={'primary'}/>
                    }
                </ListItemDecorator>
                <ListItemContent>
                    <Typography
                        level="title-sm"
                        sx={{
                            mb: 1,
                        }}
                    >
                        <Tooltip
                            title={this.props.attachment.uploadname}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                            >
                                {
                                    this.props.attachment.link_str?
                                        <Link
                                            href={this.props.attachment.link_str}
                                            target={'_blank'}
                                            noWrap
                                        >
                                            {this.props.attachment.link_str}
                                        </Link>:
                                        <Link
                                            onClick={this.download.bind(this)}
                                            noWrap
                                        >
                                            {this.props.attachment.uploadname}
                                        </Link>
                                }
                                {
                                    this.state.download?
                                        <CircularProgress
                                          size="sm"
                                        />:
                                        null
                                }
                            </Stack>
                        </Tooltip>
                    </Typography>
                    <Typography
                        level={'body-sm'}
                        sx={{mb: 1}}
                    >
                        {this.props.attachment.created_on}
                    </Typography>
                    {
                        this.props.attachment.desc?
                            <Typography
                                level={'body-sm'}
                                sx={{mb: 1}}
                                noWrap
                            >
                                {this.props.attachment.desc}
                            </Typography>:
                            null
                    }
                    <Stack
                        direction={'row'}
                        spacing={2}
                        sx={{
                            flexWrap: 'wrap',
                        }}
                    >
                        <Typography level={'body-sm'}>Автор: </Typography>
                        <ProfileHorizontalByProps
                            user={this.props.attachment.owner.user}
                        />
                    </Stack>

                    <Stack
                        direction={'row'}
                        spacing={2}
                        sx={{
                            flexWrap: 'wrap',
                            justifyContent: "flex-start",
                            alignItems: "center",
                        }}
                    >
                        <Typography level={'body-sm'}>Команда: </Typography>
                        {
                            this.props.attachment.team.map((s) => (
                                <ProfileHorizontalByProps
                                    user={s.user}
                                />
                            ))
                        }
                        {
                            this.props.attachment.owner.id === this.context.subscriberObject.id?
                                <ConfidentialAttachmentAddMember
                                    attachment={this.props.attachment}
                                    callBack={this.props.callBack}
                                />:
                                null
                        }
                    </Stack>
                    {
                        (this.props.attachment.owner.id === this.context.subscriberObject.id && !this.props.hideDelete)?
                            <Link
                                level="body-xs"
                                color={'danger'}
                                onClick={this.destroy.bind(this)}
                            >
                                <DeleteIcon
                                    sx={{mr: 1}}
                                /> Удалить
                            </Link>:
                            null
                    }
                </ListItemContent>
            </ListItem>
        )
    }
}

export default ConfidentialAttachmentCard